import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Nav, NavItem} from './TyreSectionNav.style';

const TyreSectionNav = ({sections, activeSection}) => {
  const [currentSection, setCurrentSection] = useState(activeSection);

  useEffect(() => {
    setCurrentSection(activeSection);
  }, [activeSection]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      setCurrentSection(sectionId);

      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <Nav>
      {sections.map(section => (
        <NavItem
          key={section.id}
          type="button"
          $active={currentSection === section.id}
          aria-current={currentSection === section.id ? 'true' : undefined}
          onClick={() => scrollToSection(section.id)}
        >
          {section.label}
        </NavItem>
      ))}
    </Nav>
  );
};

TyreSectionNav.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeSection: PropTypes.string,
};

export default TyreSectionNav;

